<template>
  <div class="column-select-column-item">
    <div class="column-select-column-item__parent">
      <DropdownButton
        v-if="hasChildren"
        :value="isOpen"
        class="column-select-column-item__toggle-open"
        @input="toggleOpen"
      />
      <MCheckbox
        :value="isParentSelected"
        :intermediate="isSomeSelected"
        :disabled="item.disabled"
        :label-text="item.name"
        :class="{
          'column-select-column-item__checkbox_no-children': !hasChildren
        }"
        @input="toggleParent($event)"
      />
      <template v-if="item.icons">
        <MIcon
          v-for="(i, idx) in item.icons"
          :key="idx"
          :icon="i"
          class="column-select-column-item__icon"
        />
      </template>
    </div>
    <template v-if="hasChildren && isOpenComputed">
      <MCheckbox
        v-for="child in item.children"
        :key="child.id"
        :disabled="child.disabled"
        :value="itemIsActive(child.id)"
        :label-text="child.name"
        class="column-select-column-item__child"
        @input="toggleItem(child.id, $event)"
      />
    </template>
  </div>
</template>

<script>
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';
  import iconArrow from 'assets/icons/bullet-arrow.svg';
  import DropdownButton from 'components/Inputs/Basic/DropdownButton';
  import MIcon from 'components/Design/MIcon';

  export default {
    name: 'ColumnsSelectColumnItem',
    components: {MIcon, DropdownButton, MCheckbox},
    props: {
      selectedItems: {
        type: Array,
        default: Array
      },
      item: {
        type: Object,
        required: true
      },
      isSearching: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        iconArrow,
        isOpen: false
      };
    },
    computed: {
      isOpenComputed () {
        return this.isSearching || this.isOpen;
      },
      hasChildren () {
        return Boolean(this.item.children);
      },
      isParentSelected () {
        return this.areAllSelected;
      },
      isSomeSelected () {
        return !this.areAllSelected && this.selectedChildItems.length > 0;
      },
      allItemIds () {
        if (!this.hasChildren) {
          return [this.item.id];
        }
        return this.item.children.map(i => i.id);
      },
      allItemEnabledIds () {
        if (this.item.disabled) {
          return [];
        }
        if (!this.hasChildren) {
          return [this.item.id];
        }
        return this.item.children.filter(c => !c.disabled).map(i => i.id);
      },
      selectedChildItems () {
        return this.allItemIds.filter(i => this.selectedItems.includes(i));
      },
      areAllSelected () {
        return this.selectedChildItems.length === this.allItemIds.length;
      }
    },
    mounted () {
      if (!this.areAllSelected && this.selectedChildItems.length !== 0) {
        this.isOpen = true;
      }
    },
    methods: {
      itemIsActive (id) {
        return this.selectedItems.includes(id);
      },

      toggleOpen () {
        this.isOpen = !this.isOpen;
      },
      toggleParent (status) {
        this.$emit('toggleItems', {status, itemIds: this.allItemEnabledIds});
      },
      toggleItem (itemId, status) {
        this.$emit('toggleItems', {status, itemIds: [itemId]});
      }
    }
  };
</script>


<style>
  .column-select-column-item .m-checkbox__label {
    white-space: normal;
    overflow: auto;
  }

  .column-select-column-item .m-checkbox {
    align-items: flex-start;
  }

  .column-select-column-item__parent {
    display: flex;
  }

  .column-select-column-item__child {
    margin-top: 12px;
    margin-left: 30px;
  }

  .column-select-column-item {
    margin-top: 12px;
  }

  .column-select-column-item__icon {
    flex-grow: 0;
    flex-shrink: 0;

    width: 16px;
    height: 16px;

    margin-left: 8px;
  }

  .column-select-column-item__toggle-open {
    /* dirty think to make beautiful layout and not to break anything */
    position: relative;
    top: -1px;

    flex-grow: 0;
    flex-shrink: 0;

    margin-right: 4px;
  }

  .column-select-column-item__checkbox_no-children {
    margin-left: 20px;
  }

  .column-select-column-itme__toggle-oren_open {
    transform: rotate(90deg);
  }
</style>
